import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { panelBorder, redColors } from 'theme/colors';

interface ServiceCardProps {
  title: string;
  icon: React.ReactNode;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ title, icon }: ServiceCardProps) => {
  return (
    <Stack
      spacing={2}
      sx={{
        border: panelBorder,
        borderRadius: '14px',
        p: 3,
        bgcolor: 'rgba(255,255,255,0.035)',
        backdropFilter: 'blur(6px)',
      }}
    >
      <Box
        sx={{
          width: 42,
          height: 42,
          borderRadius: '11px',
          bgcolor: alpha(redColors.dark, 0.12),
          border: `1px solid ${alpha(redColors.dark, 0.25)}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& svg': { width: 22, height: 22 },
        }}
      >
        {icon}
      </Box>
      <Typography variant='p3' sx={{ color: 'typography.light' }}>
        {title}
      </Typography>
    </Stack>
  );
};

export default ServiceCard;
